/** @format */

import { useState } from "react";
import { DatePicker, Space } from "antd";
//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

import { ServiceFolder } from "./folder";
import { InternalNav } from "../../components/internalNav";
import { CalenderIcon } from "../../components/svg";

import Table from "../../components/Table2";
import { ColumnServicesStats } from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategoriesStatistics,
  getAllCategoriesTabel,
} from "../../store/categoriesStatistics";
import { Spinner1 } from "../../components/spinners/Spinner1";
import InputCalender from "../../components/inputs/inputCalender";

const ServiceStats = () => {
  const [activeCalender, setActiveCalender] = useState("today");
  const [idService, setIdService] = useState();
  const [showAll, setShowAll] = useState(false);

  const dispatch = useDispatch();
  const render = useSelector((state) => state.toggleState.value.render);
  const categories = useSelector(
    (state) => state.categoriesStatistics.allCategories
  );
  const categoriesTabel = useSelector(
    (state) => state.categoriesStatistics.allCategoriesTabel
  );
  const categoriesLoading = useSelector(
    (state) => state.categoriesStatistics.loading
  );
  const onChange = (date, dateString) => {
    dateString = dateString.length ? dateString : "today";
    setActiveCalender(dateString);
  };

  useEffect(() => {
    dispatch(
      getAllCategoriesStatistics(
        `/categories_statistics${
          activeCalender.length ? `/${activeCalender}` : ""
        }`
      )
    );
    dispatch(
      getAllCategoriesTabel(
        `/services_by_categories_statistics${idService ? `/${idService}` : ""}${
          activeCalender.length ? `/${activeCalender}` : ""
        }`
      )
    );
  }, [dispatch, render, idService, activeCalender]);

  return (
    <NavbarAndSidebar>
      <div className='profile__head mb__small'>
        <HeadTitle title=' احصائيات الخدمات' />
        <div className='services-stats-calender'>
          <InternalNav
            active={activeCalender}
            setActive={setActiveCalender}
            from='service-stats'
            display='row'
          />
          <Space direction='vertical'>
            <DatePicker
              onChange={onChange}
              style={{
                textAlign: "center",
                width: "100%",
                position: "relative",
                padding: "13px",
              }}
            />
          </Space>
          {/* <CalenderIcon /> 
          <InputCalender /> */}
        </div>
      </div>
      <div className='mb__small' />
      {!showAll ? (
        <>
          <div className='grid-folders  folders-container'>
            {categories.length === 0 ? (
              <h4>لا يوجد بيانات لهذه الفتره</h4>
            ) : (
              <>
                <ServiceFolder
                  active={true}
                  categories={categories}
                  setIdService={setIdService}
                />
                {categories.length >= 2 && (
                  <ServiceFolder
                    active={false}
                    link={true}
                    showAll={showAll}
                    setIdService={setIdService}
                    setShowAll={setShowAll}
                    categories={categories}
                  />
                )}
              </>
            )}
          </div>

          <div>
            {/* <DynamicTable tableColumn={tableColumnServicesStats} /> */}
            <Table
              data={categoriesTabel}
              header={ColumnServicesStats}
              // link="/profile-guarantor/"
              // getSearchValue={getSearchValue}
              // searchValues={searchValues}
              name='serviceStats'
            />{" "}
            {categoriesLoading && <Spinner1 />}
          </div>
        </>
      ) : (
        <div className='grid-folders  folders-container'>
          {categories.map((key) => (
            <ServiceFolder
              active={false}
              categories={categories}
              setShowAll={setShowAll}
              setIdService={setIdService}
            />
          ))}
          {categoriesLoading && <Spinner1 />}
        </div>
      )}
    </NavbarAndSidebar>
  );
};
export default ServiceStats;
